import { render, staticRenderFns } from "./CompetitorView.vue?vue&type=template&id=3386fd66&"
import script from "./CompetitorView.vue?vue&type=script&lang=ts&"
export * from "./CompetitorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports